import {
    allWizardSteps,
    DATA_CREATION_PANEL_SELECTOR,
    DATA_CREATION_TRIGGER_SELECTOR,
    pickSteps,
} from './wizardSteps';

/**
 * "Take the guided tour" — the demo of the "Create a model" wizard, run end
 * to end on a client-side mock task (nothing is sent to the server, nothing
 * is persisted). The runner auto-fills each mark's content when the user
 * clicks (or types on) the highlighted element or the bubble's Next (see
 * `demo/demoScript.js`); Back revisits the previous mark, turning the page
 * back when needed; once the last mark of a page is done the page's Next
 * button spins for 1.5 s and the wizard moves on by itself.
 * The Train page carries no mark: the user opens it with Advanced already
 * expanded and clicks "Finish & Create Model" to reach "You're all set".
 *
 * Step definitions live in `./wizardSteps.js`; this walkthrough uses the
 * subset below unchanged, in wizard order. Left out on purpose: the
 * single/multi question (the demo task is pre-filled with "No"), the
 * "Need a dataset?" / "Download template" hints, the input-field and
 * label-mapping marks after the preview, and every mark on Train.
 */

export const CREATE_MODEL_WALKTHROUGH_ID = 'create_model';

export const DEMO_STEP_IDS = Object.freeze([
    // Business goals
    'task-name',
    'task-type',
    'labels',
    'fallback-label',
    'priority-ranking',
    // Data collection
    'upload-data',
    'data-creation',
    'example-preview',
    // Model setup
    'commercial-model',
    'system-prompt',
    'user-prompt',
    'output-format',
    // Data editor
    'label-view',
    'row-label',
    'reviewed',
]);

export const CREATE_MODEL_WALKTHROUGH_STEPS = pickSteps(allWizardSteps, DEMO_STEP_IDS);

export const createModelWalkthrough = {
    id: CREATE_MODEL_WALKTHROUGH_ID,
    /** Blue "tour" bubble: "Step N/Total" counter, Back + Next (Next auto-fills, like acting on the anchor). */
    style: 'tour',
    /** Demo state is never written to `user.preferences` — a reload starts over. */
    ephemeral: true,
    steps: CREATE_MODEL_WALKTHROUGH_STEPS,
    // The pointer is not resolved until these slices are published: the
    // wizard publishes `form` only once a reopened draft is hydrated, so the
    // predicates never run against an empty form and move the tour off the
    // step it was left at.
    requiredContext: ['form'],
};

export { DATA_CREATION_PANEL_SELECTOR, DATA_CREATION_TRIGGER_SELECTOR };

export default createModelWalkthrough;
